// Tabs
class Tabs {
	// Bind Events
	static init() {
		if ( window.location.hash ) {
			Tabs.show();
		}
		window.addEventListener( 'hashchange', Tabs.show );
	}

	// Show
	static show() {
		const id = window.location.hash.replace( '#', '' );
		const targetTab = document.getElementById( id );
		if ( ! targetTab || targetTab.getAttribute( 'role' ) !== 'tabpanel' ) {
			return false; // Tab Element with this ID does not exist.
		}

		const tabItem = document.querySelector( '[role="tab"][aria-controls="' + id + '"]' );

		// Tabs nav
		tabItem.parentElement.querySelector( '[role="tab"][aria-selected="true"]' ).setAttribute( 'aria-selected', 'false' );
		tabItem.setAttribute( 'aria-selected', 'true' );

		// Tabs content
		tabItem.parentElement.parentElement.querySelector( '[role="tabpanel"][aria-hidden="false"]' ).setAttribute( 'aria-hidden', 'true' );
		targetTab.setAttribute( 'aria-hidden', 'false' );
		targetTab.setAttribute( 'tabindex', '-1' );
		targetTab.focus();
	}
}

export default Tabs;
